import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';


export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#services' },
    { name: 'Pickup & Delivery', href: '#pickup' },
    { name: 'Locations', href: '#locations' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-white py-4'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between relative">
          
          {/* Left: Main Logo & Tagline */}
          <div className="flex flex-col items-start z-10">
            <h1 className="text-lg md:text-2xl font-bold text-[#6b7d5d] leading-none tracking-tight">
              Bennett Valley Dry Cleaners
            </h1>
            <span
              className="text-sm md:text-base font-light text-gray-500 leading-tight"
              style={{
                fontWeight: "bold",
                fontStyle: "italic"
              }}>
              & Central Cleaners
            </span>
          </div>

          {/* Center: Navigation (Desktop) */}
          <nav className="hidden lg:flex items-center gap-6 absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2">
            {navLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-gray-600 hover:text-[#6b7d5d] transition-colors tracking-wide"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Right: Partner Logo & Call Button */}
          <div className="hidden lg:flex items-center gap-6 z-10">


            {/* Call Button */}
            <a 
              href="tel:7075402900" 
              className="bg-[#6b7d5d] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#5a6b4c] transition-colors shadow-sm flex items-center gap-2"
            >
              <Phone size={16} />
              <span>Call Us</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center gap-4 lg:hidden">
             <a 
              href="tel:7075402900" 
              className="bg-[#6b7d5d] text-white p-2 rounded-full shadow-sm"
            >
              <Phone size={18} />
            </a>
            <button 
              className="text-gray-600 hover:text-[#6b7d5d] transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

        </div>
      </div>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-xl p-4 flex flex-col gap-4 animate-in slide-in-from-top-5">
          {navLinks.map((link) => (
            <a 
              key={link.name}
              href={link.href}
              className="text-lg font-medium text-gray-700 hover:text-[#6b7d5d] py-2 border-b border-gray-50 last:border-0"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <div className="flex items-center justify-between pt-4 mt-2 border-t border-gray-100">
             <div className="flex flex-col">
               <span className="text-xs text-gray-400 uppercase tracking-wider mb-1"></span>

             </div>
          </div>
        </div>
      )}
    </header>
  );
}
